export default __webpack_public_path__ + "static/media/closet3-1920w.07ad4e8a.avif";